/**
 * Helper function to manage visibility settings for components
 * based on boolean data.
 * @param {object} props
 * @param {boolean} props.value
 * @param {boolean} [props.hideWhenAnswerIsNo=false] - some customers want to hide this information if the answer is 'no'
 * @param {boolean} [props.noContentMeansNo=false] - alters behavior when the question hasn't been answered to be treated as if the customer answered 'no'
 * @param {boolean} [props.alwaysDisplay=false] - force this component to always render; TODO: perhaps this is actually a design-time, infosheet-level attribute to see what fields are actually on the page.
 * @returns
 */
export default function shouldRenderBoolean({
  value,
  hideWhenAnswerIsNo = false,
  alwaysDisplay = false,
  noContentMeansNo = false,
}) {
  if (alwaysDisplay) return true;
  switch (value) {
    case true:
      return true;
    case false:
      return !hideWhenAnswerIsNo;
    case null:
      return !!noContentMeansNo;
    default:
      console.log("Error: there shouldn't be a default");
      return false;
  }
}
